import { render, staticRenderFns } from "./ModalRecFacial2.vue?vue&type=template&id=59b4d80c&scoped=true"
import script from "./ModalRecFacial2.vue?vue&type=script&lang=js"
export * from "./ModalRecFacial2.vue?vue&type=script&lang=js"
import style0 from "./ModalRecFacial2.vue?vue&type=style&index=0&id=59b4d80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4d80c",
  null
  
)

export default component.exports